/**
 * Enterprise loader.
 * @param {any} props
 * @returns {any}
 */
export default function EnterpriseLoader(props) {
  return {
    state: {
      enterprises: props.enterprises || [],
      query: {
        s: '',
        theme: '',
        sort: '',
        page: 1,
      },
      reset: false,
      nextPage: 2,
    },
    path: '/entreprise/?isAjaxRequest=1&',
    async changeFilter(event = null) {
      if (event?.detail?.type) {
        this.state.query[event.detail.type] = event.detail.newValue;
      }
      this.state.query.page = 1;
      this.state.nextPage = 2;
      this.state.reset = true;
      await this.getEnterpriseItems();
    },
    async getEnterpriseItems() {
      // @todo replace with URLSearchParams
      const query = Object.keys(this.state.query)
        .reduce((acc, key) => {
          const value = this.state.query[key];
          if (value && ((typeof value === 'string' && value.length) || typeof value === 'number')) {
            acc.push(`${key}=${value}`);
          }
          return acc;
        }, [])
        .join('&');
      try {
        await fetch(String(this.path) + query)
          .then((response) => response.json())
          .then((data) => {
            if (
              this.state.reset ||
              (data.loadNextPage && data.loadNextPage === this.state.nextPage)
            ) {
              this.state.enterprises = data.posts;
              this.state.reset = false;
            } else {
              this.state.enterprises = [...this.state.enterprises, ...data.posts];
            }

            if (data.loadNextPage) {
              this.state.nextPage = data.loadNextPage;
              this.$refs.loadNextPage.style.display = 'block';
            } else {
              this.$refs.loadNextPage.style.display = 'none';
            }

            /* if (data.loadNextPage && data.loadNextPage === this.state.nextPage) {
              this.state.enterprises = data.posts;
            } else {
              this.state.enterprises = [...this.state.enterprises, ...data.posts];
            }
            if (data.loadNextPage) {
              this.$refs.loadNextPage.style.display = 'block';
              this.state.nextPage = data.loadNextPage;
            } else {
              this.$refs.loadNextPage.style.display = 'none';
            } */
          });
      } catch {
        // console.log(e);
      }
    },
    async onClickSearch(event) {
      event.preventDefault();
      this.state.query.s = this.$refs.searchInput.value;
      await this.changeFilter();
    },
    async onClickLoadMore() {
      this.state.query.page = this.state.nextPage;
      await this.getEnterpriseItems();
    },
    /**
     * @todo Replace with URLSearchParams.
     * @param   {any} obj
     * @returns {string}
     */
    serialize(obj) {
      const params = [];

      for (const key in obj) {
        // eslint-disable-next-line no-prototype-builtins
        if (obj.hasOwnProperty(key)) {
          params.push(`${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`);
        }
      }

      return params.join('&');
    },
    init() {
      document
        .querySelector('.filters')
        .addEventListener('filters:change', (event) => this.changeFilter(event));
    },
    mounted() {
      this.init();
    },
  };
}
